import { lang } from '@umu/ukit-lang';
/*
 * @author: wayou
 * @date: 2018-12-10 11:17:14
 * @description: AI 报告中关键词组件，包含词云和高频词的展示
 */

import React, { Component } from 'react';
import KeyWrodsEmpty from '../@keyWrodsEmpty/keyWrodsEmpty';
import KeyWrodsProcessing from '../@keyWrodsProcessing/keyWrodsProcessing';
import WordCloud, { BackgroundType } from './wordCloud/wordCloud';
import { getWordCloudData } from './wordCloudUtil';
import { KeyWordItem } from './keyWordItem/keyWordItem';
import { IKeywordItem, AI_KEYWORD_RULE, IElementSetup, IHomeworkInfo, API_TYPE } from '@umu/umu-types';
import { isEmptyObject, isSame } from '@umu/umu-util';
import { components } from 'common';
export { AI_KEYWORD_RULE } from '@umu/umu-types';
const { If, Loading } = components;
import './keywordsSection.scss';
import {fetchData} from '@umu/umu-fetch';

export const keywordRuleName = {
    [AI_KEYWORD_RULE.UNOPEN]: '',
    [AI_KEYWORD_RULE.EXACT]: lang('精确匹配'),
    [AI_KEYWORD_RULE.AI]: lang('智能匹配'),
};

interface IKeywordsSectionProps {
    keywords: IKeywordItem[];
    frequencyWords: IKeywordItem[];
    isProcessing: boolean;
    keywordTitle?: string;
    keywordSubTitle?: string;
    keywordMinScore?: number;
    keywordFullScore?: number;
    aiKeywordMatchRule?: AI_KEYWORD_RULE;
    aiKeywordEvaluationScore?: number;
    setupInfo?: IElementSetup;
    homeworkInfo?: IHomeworkInfo;
    isPc?:boolean
}
interface IKeywordSectionState{
    isSubmittedHomework:boolean,
    isCheckingSubmitted:boolean,
}

export default class KeywordsSection extends Component<IKeywordsSectionProps, IKeywordSectionState> {
    constructor(props:IKeywordsSectionProps){
        super(props);
        this.state={
            isSubmittedHomework:false,
            isCheckingSubmitted:true
        }
    }
    componentDidMount(): void {
        const parentId=this.props.homeworkInfo?.parent_id;
        if(parentId && !this.props.isPc){
            this.checkIsHomeworkSubmitted(parentId)
        }
        if(this.props.isPc){
            this.setState({
                isCheckingSubmitted:false
            })
        }
    }
    public render() {
        const { keywordTitle, keywordSubTitle, isProcessing, keywords, frequencyWords } = this.props;

        if (isProcessing) {
            return <KeyWrodsProcessing />;
        }

        if (keywords.length === 0 && frequencyWords.length === 0) {
            return <KeyWrodsEmpty title={keywordTitle} subTitle={keywordSubTitle} />;
        }
        return (
            <div className="keywords-section">
                {this.renderScore()}

                <If condition={this.state.isCheckingSubmitted}>
                    <Loading/>
                </If>
                <If condition={!this.state.isCheckingSubmitted}>
                    <>
                        {this.renderWordCloud(keywords, frequencyWords)}
                        {this.renderKeywordsList(keywords)}
                    </>
                </If>
                {this.renderFrequencyList(frequencyWords)}
            </div>
        );
    }

    private renderScore() {
        const {
            aiKeywordMatchRule,
            keywordFullScore = 100,
            keywordMinScore = 0,
            aiKeywordEvaluationScore = 0,
        } = this.props;
        if (!aiKeywordMatchRule || isSame(aiKeywordMatchRule, AI_KEYWORD_RULE.UNOPEN)) {
            return null;
        }
        return (
            <div className="keywords-list-wrap">
                <div className="keywords-list-title">
                    {lang('关键词评分')}-{keywordRuleName[aiKeywordMatchRule]}
                </div>
                <div className="evaluation-score-body">
                    <div className="evaluation-score">
                        {aiKeywordEvaluationScore}
                        <span>{lang('分')}</span>
                    </div>
                    <div className="score-limit">
                        <span className="full-score">
                            {lang('AI关键词满分') + lang('：')}
                            {lang('{$0{0= 分,1= 分}}', keywordFullScore)}
                        </span>
                        {keywordMinScore > 0 ? (
                            <span className="min-score">
                                {lang('最低提交分数') + lang('：')}
                                {lang('{$0{0= 分,1= 分}}', keywordMinScore)}
                            </span>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }

    private renderWordCloud(keywords: IKeywordItem[], frequencyWords: IKeywordItem[]) {
        const data = getWordCloudData(keywords, frequencyWords);
        if (data.length === 0 || !this.showAiKeyword()) {
            return null;
        }
        let backgroundType: BackgroundType = 'color';
        let label = lang('关键词');
        if (keywords.length === 0) {
            label = lang('高频词');
            backgroundType = 'grey';
        }
        return (
            <div className="keywords-cloud-wrap">
                <div className="keywords-list-title">{label}</div>
                <WordCloud words={data} backgroundType={backgroundType} />
            </div>
        );
    }

    private renderKeywordDashboard(keywords: IKeywordItem[]) {
        if (!keywords.length) {
            return null;
        }
        const table = keywords.map((keyword, i) => {
            return (
                <div className="tr-keyword" key={i}>
                    <KeyWordItem data={keyword} matchRule={this.props.aiKeywordMatchRule} />
                </div>
            );
        });

        return (
            <div className="keywords-dashboard">
                <div className="label">
                    <div className="th-word">{lang('关键词')}</div>
                    <div className="th-result">{lang('AI识别结果')}</div>
                </div>
                {table}
            </div>
        );
    }
    private checkIsHomeworkSubmitted(parentId:number) {
        this.setState({
            isCheckingSubmitted:true
        })
        const api= {
            url: '/uapi/v1/homework/my',
            type: API_TYPE.GET,
        }
        return fetchData(api,{parent_id:parentId}).then((res: any)=>{
            const isSubmitted=!isEmptyObject(res.data)
            this.setState({
                isSubmittedHomework:isSubmitted,
                isCheckingSubmitted:false
            })
        })
    }
    private showAiKeyword(){
        const { show_ai_keyword_after, show_ai_keyword_before } = this.props.setupInfo || {};
        if(this.props.isPc){
            return true;
        }
        if (this.state.isSubmittedHomework) {
            return  show_ai_keyword_after == 1;
        } else {
            return show_ai_keyword_before == 1;
        }
    }

    private renderKeywordsList(keywords: IKeywordItem[]) {
        const { aiKeywordMatchRule } = this.props;

        if (keywords.length === 0 || isSame(aiKeywordMatchRule, AI_KEYWORD_RULE.UNOPEN)) {
            return null;
        }
        const label = lang('关键词');
        return (
            <div className="keywords-list-wrap">
                <div className="keywords-list-title">{label}</div>

                <If condition={this.showAiKeyword()}>
                    <>
                        <p>{lang('讲师设置的作业中应该提及的目标关键词')}</p>
                        <div className="keywords-list-body">{this.renderKeywordDashboard(keywords)}</div>
                    </>
                </If>
                <If condition={!this.showAiKeyword()}>
                    <p>{lang('讲师已设置不展示关键词')}</p>
                </If>
            </div>
        );
    }

    private renderFrequencyList(frequencyWords: IKeywordItem[]) {
        if (frequencyWords.length === 0) {
            return null;
        }
        const label = lang('高频词');

        const { keywords } = this.props;
        const showHeader = keywords.length !== 0;
        return (
            <div className="keywords-list-wrap frequency-keywords-wrap">
                {showHeader ? (
                    <>
                        <div className="keywords-list-title">{label}</div>
                        <p>{lang('除讲师设置的关键词外，作业中提及的高频词')}</p>
                    </>
                ) : null}
                <div className="keywords-list-body">{this.renderTable(label, frequencyWords)}</div>
            </div>
        );
    }

    private renderTable(label: string, keywords: IKeywordItem[]) {
        if (!keywords.length) {
            return null;
        }
        return (
            <table className="keywords-table">
                <thead>
                    <tr>
                        <th>{label}</th>
                        <th>{lang('AI识别次数')}</th>
                    </tr>
                </thead>
                <tbody>
                    {keywords.map((keyword) => {
                        return (
                            <tr key={keyword.word} className={`${keyword.count === 0 ? 'row-keyword-zero' : ''}`}>
                                <td>{keyword.word}</td>
                                <td>{keyword.count}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    }
}
